// extracted by mini-css-extract-plugin
export default {"video":"SpaceJam_video__wo07y","videoMobile":"SpaceJam_videoMobile__77qLv","imageRow":"SpaceJam_imageRow__xrE5Q"};